var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "set-date-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _c(
          "a-radio-group",
          {
            attrs: { "button-style": "solid" },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.dateType,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "dateType", $$v)
              },
              expression: "localConfig.dateType",
            },
          },
          [
            _c("a-radio-button", { attrs: { value: "static" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.static"))),
            ]),
            _vm._v(" "),
            _c("a-radio-button", { attrs: { value: "relative" } }, [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.relative"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.localConfig.dateType === "static"
      ? _c(
          "div",
          { staticClass: "config-field" },
          [
            _c("a-date-picker", {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: _vm.$t("taskModuleRules.selectDate"),
                format: "DD/MM/YYYY",
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.staticDate,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "staticDate", $$v)
                },
                expression: "localConfig.staticDate",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.localConfig.dateType === "relative"
      ? _c("div", { staticClass: "relative-config" }, [
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.value")))]),
              _vm._v(" "),
              _c("a-input-number", {
                staticStyle: { width: "100%" },
                attrs: { placeholder: _vm.$t("taskModuleRules.exampleThree") },
                on: { change: _vm.emitChange },
                model: {
                  value: _vm.localConfig.relativeValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.localConfig, "relativeValue", $$v)
                  },
                  expression: "localConfig.relativeValue",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.unit")))]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.relativeUnit,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "relativeUnit", $$v)
                    },
                    expression: "localConfig.relativeUnit",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "minutes" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.minutes"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "hours" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.hours"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "days" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.days"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }